import { takeLatest, put, call } from 'redux-saga/effects';
import { TaskTypesTypes } from '../types';
import { getTaskTypesList } from '../actions';
import { getTaskTypesFirebase } from '../repository';

export function* requestGetTaskTypesListSaga(): unknown {
    try {
        const taskTypes = yield call(getTaskTypesFirebase);
        yield put(getTaskTypesList(taskTypes));
    } catch (err: unknown) {
        yield put(getTaskTypesList([]));
    }
}

export default [takeLatest(TaskTypesTypes.REQUEST_GET_TASK_TYPES_LIST, requestGetTaskTypesListSaga)];
